import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { lazy, Suspense } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
var LazyLeftMenuDesktop = /*#__PURE__*/lazy(function () {
  return import(/* webpackChunkName: "main-menu-left-menu-desktop" */"./LeftMenuDesktop");
});
var LeftMenuDesktop = function LeftMenuDesktop(props) {
  return /*#__PURE__*/_jsx(Suspense, {
    fallback: null,
    children: /*#__PURE__*/_jsx(LazyLeftMenuDesktop, _objectSpread({}, props))
  });
};
export default LeftMenuDesktop;